
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/security",
      function () {
        return require("private-next-pages/help/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/security"])
      });
    }
  